<template>
    <div :class="schoolClass + ' text-uppercase font-weight-bold'">
      <slot></slot>
    </div>
</template>
<style>
.touchy{
  /* line-height:65% !important; */
  white-space: nowrap;
  margin-bottom:0  !important;
  margin: 0;
  line-height: 70% !important;
}
</style>
<script>
export default {
  name: 'ResHL',
  computed: {
    schoolClass () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 'text-subtitle-1'
        case 'sm': return 'text-h5'
        case 'md': return 'text-h4'
        default: return 'text-h4'
      }
    }
  }
}
</script>
